// export function checkPassword() {
//     let val = data.newPassword || "";
//     let strength = 0;
//
//     let passwordCheck = {
//         tooShort: true,
//         noLowerCase: true,
//         noUpperCase: true,
//         noNumber: true,
//         noSpecialCharacter: true
//     }
//
//     if(val !== "") {
//         // If the password length is less than or equal to 8
//         if (val.length >= 8) {
//             passwordCheck.tooShort = false
//             strength += 1
//         }
//
//
//         // If the password not contains any lowercase alphabet. or any number or any special character
//         if (val.match(/[a-z]/)) {
//             passwordCheck.noLowerCase = false
//             strength += 1
//         }
//
//         // If the password not contains any uppercase alphabet. or any number or any special character
//         if (val.match(/[A-Z]/)) {
//             passwordCheck.noUpperCase = false
//             strength += 1
//         }
//
//         // If the password not contains any number.
//         if (val.match(/\d+/)) {
//             passwordCheck.noNumber = false
//             strength += 1
//         }
//         // If the password not contains any number.
//         if (val.match(/[!,@#$%^&*?_~\-().]/)) {
//             passwordCheck.noSpecialCharacter = false
//             strength += 1
//         }
//     }
//     return {
//         strength,
//         detail: passwordCheck
//     }
// }


export function checkPassword(val) {
    let strength = 0;

    let newPasswordCheck = {
        tooShort: true,
        noLowerCase: true,
        noUpperCase: true,
        noNumber: true,
        noSpecialCharacter: true
    }

    if(val !== "") {
        // If the password length is less than or equal to 8
        if (val.length >= 8) {
            newPasswordCheck.tooShort = false
            strength += 1
        }


        // If the password not contains any lowercase alphabet. or any number or any special character
        if (val.match(/[a-z]/)) {
            newPasswordCheck.noLowerCase = false
            strength += 1
        }

        // If the password not contains any uppercase alphabet. or any number or any special character
        if (val.match(/[A-Z]/)) {
            newPasswordCheck.noUpperCase = false
            strength += 1
        }

        // If the password not contains any number.
        if (val.match(/\d+/)) {
            newPasswordCheck.noNumber = false
            strength += 1
        }
        // If the password not contains any number.
        if (val.match(/[!,@#$%^&*?_~\-().]/)) {
            newPasswordCheck.noSpecialCharacter = false
            strength += 1
        }
    }

    return {
        details: newPasswordCheck,
        strength
    }
}

export function calculateProgressBar(strength) {
    switch (strength) {
        case 1:
        case 2:
        case 3:
            return {
                text: "Slabé",
                progress: 33,
                color: "#C32518"
            }
        case 4:
            return {
                text: "Priemerné",
                progress: 66,
                color: "#fcba03"
            }
        case 5:
            return {
                text: "Silné",
                progress: 100,
                color: "#3FC948"
            }
        default:
            return {
                text: "",
                progress: 0,
                color: "#888888"
            }
    }
}